<template>

	<div class="container my-3 my-md-5">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
          <div class="card-body">
						<h4 class="card-heading mb-4">Lieferschein Rechnungs Export </h4>
            <b-row>
              <div class="col-6">
						<b-form-group
              content-cols="8"
              label-cols="4"            
              label="Market Account"
              label-for="input-horizontal"            
            >
              <b-form-select v-model="formInput.marketId" :options="marketOptions"></b-form-select>
						</b-form-group>

						<b-form-group
              content-cols="8"
              label-cols="4"            
              label="Jahr"
              label-for="input-horizontal"            
            >
								<b-form-select v-model="formInput.year" :options="yearsOptions"></b-form-select>
						</b-form-group>
            
              <b-form-group
                content-cols="8"
                label-cols="4"
                label="Monat"
                label-for="input-horizontal"         
              >
                <b-form-select v-model="formInput.month" :options="monthOptions"></b-form-select>
              </b-form-group>

                <b-form-group
                  class=""
                  content-cols="8"
                  label-cols="4"            
                  label="Netto gesamt"
                  label-for="input-horizontal"            
                >
                  <b-form-input v-model="formInput.totalNetAmount"></b-form-input>
                </b-form-group>


              <div v-for="n in invoiceCount" class="mt-4" :key="n">
                <b-form-group
                  class=""
                  content-cols="8"
                  label-cols="4"            
                  label="Rechnungsbetrag"
                  label-for="input-horizontal"            
                >
                  <b-form-input v-model="formInput.invoices[n-1].invoiceAmount"></b-form-input>
                </b-form-group>

                <b-form-group
                  content-cols="8"
                  label-cols="4"            
                  label="Währung"
                  label-for="input-horizontal"            
                >
                  <b-form-select v-model="formInput.invoices[n-1].currency" :options="currencyOptions"></b-form-select>
                </b-form-group>
              </div>
              <b-btn variant="secondary" @click="addInvoice">+</b-btn>           
              <b-btn v-if="invoiceCount > 1" variant="secondary" @click="removeInvoice"> - </b-btn>
              </div>
              <div class="col-6">
                <div v-if="invoices.length > 0" class="">
                  <div v-for="(invoice, index) in invoices" :key="index" class="">
                    <span class="mt-3">Rechnung: {{invoice.invoiceAmount ? invoice.invoiceAmount : "Restbetrag"}} / {{invoice.currency ? invoice.currency : "EUR"}}</span>
                    <div class="d-flex">
                    <b-form-group class=" w-25 mt-auto" label="Brutto Umsatz" label-for="grossSum">
                      <b-form-input disabled v-model="invoice.reducedGrossSum.toFixed(2)" id="grossSum" ></b-form-input>
                    </b-form-group>
                    <b-form-group class="w-25 mt-auto" label="Ware voller Steuersatz" label-for="tax19">
                      <b-form-input disabled v-model="invoice.sum19tax.toFixed(2)" id="tax19"></b-form-input>
                    </b-form-group>
                    <b-form-group class="w-25 mt-auto" label="Ware ermäßigter Steuersatz" label-for="tax7">
                      <b-form-input disabled v-model="invoice.sum7tax.toFixed(2)" id="tax7"></b-form-input>
                    </b-form-group>                                                   
                      <b-btn class="mb-3 mt-auto" @click="downloadPdf(invoice)"><b-icon icon="download"></b-icon></b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <b-btn class="float-right" variant="primary" @click="exportFullfillment">Exportieren</b-btn>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
  props: [
    'marketAccounts', 'markets'
  ],
  data(){
    return {
      marketAccountOptions: [],
      markeOptions : [],
      startYear : 2021,
      currentYear: Number(moment().format('YYYY')),
      yearsOptions: [],      
      monthOptions: [],
      currencyOptions: [],
      formInput: {
        year: moment().format('YYYY'),
        month: '',
        marketId: '',
        marketName: '',
        totalNetAmount: '',
        invoices: [],
      },      
      invoiceCount: 1,
      invoices: [],
    }
  },
  computed: {
    marketName () {
      const market = this.marketOptions.find(market => market.value === this.formInput.marketId)
      return market.text
    }
  },
  methods:{
    exportFullfillment(){
      this.formInput.marketName = this.marketName;
      console.log(this.formInput.marktName);
      axios.post('saleslist/fullfillment', this.formInput)
      .then(res => {
        console.log(res);
        this.invoices = res.data;

        this.invoices.forEach(invoice => {
          const b64String = invoice.base64String;
          const binaryString = atob(b64String);
          const view = new Uint8Array(Array.from(binaryString).map(char => char.charCodeAt(0)));
          invoice.blobUrl = window.URL.createObjectURL(new Blob([view], { type: 'application/pdf' }));
        });
        console.log(this.invoices);
      })
      .catch(err => console.log(err))
    },
    addInvoice(){
      this.invoiceCount ++;
      this.formInput.invoices.push(
        {
          invoiceAmount: '',
          currency: '',
        })
    },
    removeInvoice(){
      this.invoiceCount --;
      this.formInput.invoices.pop();
    },
    cutDecimals(number){
      return number.toFixed(2);
    },
    downloadPdf(invoice){
      const link = document.createElement('a');
      link.href = invoice.blobUrl;
      link.setAttribute('download', this.formatFileName(invoice)+'.pdf');
      document.body.appendChild(link);
      link.click();
    },
    formatFileName(invoice){
      const cur =   invoice.currency ? invoice.currency : 'EUR';
      const date = moment(invoice.startDate).format("MM.YYYY");
      return 'Lieferschein_' + this.marketName + '_' + cur + "_"+ date
    }
  },
  created(){
    this.monthOptions = 
    [
      { value: 1, text: 'Januar' },
      { value: 2, text: 'Februar' },
      { value: 3, text: 'März' },
      { value: 4, text: 'April' },
      { value: 5, text: 'Mai' },
      { value: 6, text: 'Juni' },
      { value: 7, text: 'Juli' },
      { value: 8, text: 'August' },
      { value: 9, text: 'September' },
      { value: 10, text: 'Oktober' },
      { value: 11, text: 'November' },
      { value: 12, text: 'Dezember' }
    ]
    this.yearsOptions = Array.from({length: this.currentYear - this.startYear + 1}, (_, index) => this.startYear + index);
    this.marketOptions = this.markets.map(ma => {
      return {
        value : ma.id,
        text: ma.name
      }
    });
    this.currencyOptions = _.uniq(this.marketAccounts.map((x) => { return x.country.currencyIso }) ).map((x) => { //.filter((x) => { return x !== 'EUR' })
      return {
        value: x,
        text: x
      };
    });
    this.formInput.invoices.push({invoiceAmount: '', currency: ''})
  },
}
</script>